import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { SButton } from "../../components/SButton";
// Mapping between the new variant/size props and SButton's props
const variantMapping = {
    default: "juicy",
    destructive: "secondary",
    outline: "secondary",
    secondary: "primary",
    ghost: "secondary",
    link: "secondary"
};
const sizeMapping = {
    default: "md",
    sm: "sm",
    lg: "lg",
    icon: "md"
};
// Utility function to combine classes
const cn = (...classes)=>classes.filter(Boolean).join(" ");
// Button variants styling
const buttonVariants = ({ variant = "default", size = "default", className })=>{
    const baseStyles = "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0";
    const variantStyles = {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
    }[variant];
    const sizeStyles = {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10"
    }[size];
    return cn(baseStyles, variantStyles, sizeStyles, className);
};
const Button = /*#__PURE__*/ React.forwardRef(({ className, variant = "default", size = "default", asChild = false, ...props }, ref)=>{
    const Comp = asChild ? Slot : SButton;
    return /*#__PURE__*/ _jsx(Comp, {
        ...props,
        ref: ref,
        className: buttonVariants({
            variant,
            size,
            className
        }),
        variant: !asChild ? variantMapping[variant] : undefined,
        size: !asChild ? sizeMapping[size] : undefined
    });
});
Button.displayName = "Button";
export { Button, buttonVariants };
